import React, { useState } from "react";

import { Layout, MetaTag } from "src/components";
import ChapterForm from "../../../components/ChapterForm";
import { Card, Col, Row, Spin } from "antd";

const CreateView = (props: any) => {
    const { onFinish, onFinishFailed, order } = props;

    return (
        <Layout
            titles={[
                { name: "Chapters", link: "book/chapter" },
                { name: "New", link: "" },
            ]}
        >
            <MetaTag title="Add Chapter" />
            <Row justify="center" align="middle">
                <Col xs={12} lg={20} md={24}>
                    <Card
                        style={{ borderRadius: "8px", padding: "12px" }}
                        title={"Chapter Create"}
                        bordered={true}
                    >
                        <ChapterForm
                            onFinish={onFinish}
                            onFinishFailed={onFinishFailed}
                            order={order}
                        />
                    </Card>
                </Col>
            </Row>
        </Layout>
    );
};

export default CreateView;
